module.exports = __webpack_public_path__ + "static/media/doorFilling2.e1023ab1.jpeg";